export interface UserPermissions {
  update?: string;
  approve?: string;
  write?: string;
  delegate?: string;
  read?: string;
  interrupt?: string;
  create?: string;
  resume?: string;
}

export interface UserResponse {
  id: string;
  name: string;
  email: string;
  roles: string[];
  permissions: UserPermissions;
  preferredUsername: string;
  companyId: string;
  uaeUuid?: string | null;
  emiratesId?: string | null;
  terminalId: string | null;
  port: string | null;
}

export type CustomStatuses = {
  statusUpponSubmiting?: string | null;
  statusUpponResubmiting?: string | null;
  statusUpponApproving?: string | null;
  statusUpponRejecting?: string | null;
  statusUpponSuspending?: string | null;
  statusUpponCancelling?: string | null;
};

export const SasTokenPrivilege = Object.freeze({
  READ: "READ",
  WRITE: "WRITE",
} as const);
export type SasTokenPrivilege = (typeof SasTokenPrivilege)[keyof typeof SasTokenPrivilege];

export const SasTokenPrefix = Object.freeze({
  GATEPASS_SECURITY_CLEARANCE: "GATEPASS_SECURITY_CLEARANCE",
  VESSEL_REGISTRATION: "VESSEL_REGISTRATION",
  VESSEL_CALL: "VESSEL_CALL",
  MOVEMENT_SERVICE: "MOVEMENT_SERVICE",
  PORT_SERVICES: "PORT_SERVICES",
  LICENSE_SERVICE: "LICENSE_SERVICE",
} as const);
export type SasTokenPrefix = (typeof SasTokenPrefix)[keyof typeof SasTokenPrefix];

export interface SasTokenRequestPayload {
  prefix: SasTokenPrefix;
  contentType: string | null;
  privilege: SasTokenPrivilege;
  blobUrl: string | null;
}

export interface SasTokenResponse {
  blobUrl: string;
  sasToken: string;
  expiresAt: string;
}
